export const validateMessage = {
  required: '入力は必須です',
  utm: 'UTMポイントを正しく入力してください',
  range: '100m から 10000m の範囲で入力してください',
  time: '正しい時間を入力しください',
  timeRange: '正しい時間範囲で入力してください',
  colorRange: '左隣より大きく右隣より小さな数値を入力してください',
  patStartTime: '開始時刻は現在時刻より前を入力してください。',
};

/**
 * validateLowerCase
 *
 * @param str {string}
 * @returns {Boolean}
 */
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/**
 * validateUpperCase
 *
 * @param str {string}
 * @returns {Boolean}
 */
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/**
 * validatAlphabets
 *
 * @param str {string}
 * @returns {Boolean}
 */
export function validatAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/**
 * validate email
 * @param email
 * @returns {Boolean}
 */
export function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}
